<app-title>過去分を見る</app-title>
<mat-form-field>
    <input matInput [formControl]="monthControl" readonly>
    <input matInput [matDatepicker]="picker" [max]="maxDate" [formControl]="dateInput" hidden readonly>
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker startView="year" (monthSelected)="onMonthSelected($event)"></mat-datepicker>
</mat-form-field>
<app-account-dashboard-list [month]="monthLabel"></app-account-dashboard-list>